export default __webpack_public_path__ + "static/media/ЦАХИМ ХЭРЭГЛЭЭ.7096d7e3.pdf";